export const paginationLimit = 10;

export const directions = {
  next: 1,
  previous: 2,
};

export const imageResizedKey = "540px";
export const imageSubscriptionResizedKey = "234px";
